import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Simple } from '../../../templates/Simple';

export const PeriodicDelayed: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/PeriodicDelayed.${label}.${locale}.json`)}>
      <PeriodicDelayedComponent />
    </I18nProvider>
  );
};

export const PeriodicDelayedComponent: FC = () => {
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { trackFunnelCompleted } = useTracking();
  const { state } = useMeterReadingsFlow();

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.PeriodicDelayed'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Simple
      title={t('periodicDelayed.title')}
      content={t('periodicDelayed.content')}
      nextStepList={[
        {
          label: t('periodicDelayed.nextStep1'),
          state: 0,
        },
        {
          label: t('periodicDelayed.nextStep2'),
          state: 1,
        },
        {
          label: t('periodicDelayed.nextStep3'),
          state: 1,
        },
      ]}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('periodicDelayed.imageSrc')}`,
        },
      }}
    />
  );
};
